// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__nxL5Z","modal-header":"Modal_modal-header__2J4Jk","close-button":"Modal_close-button__wqbvE","modal-content":"Modal_modal-content__ceA7X"};